import React from 'react';


const About = () => (
  <h2>About</h2>
);

export default About;